import {
  type UserSession,
  type UserSessionTeam
} from 'types/api/users/sessions/user-session'

export const NO_TEAM = 'NO_AVAILABLE_TEAM'

export function getSessionData(session: UserSession, activeTeamId?: string) {
  const hasSession = Boolean(session?.company_id)
  if (!hasSession) {
    return {
      sessionToStart: {} as UserSession,
      activeTeam: { identifier: activeTeamId }
    }
  }

  const activeTeam = session.teams.length
    ? session.teams.find((team) => team.identifier === activeTeamId) ||
      session.teams[0]
    : ({ identifier: NO_TEAM } as UserSessionTeam)

  return { sessionToStart: session, activeTeam }
}

export const defaultScenarioTab = () =>
  sessionStorage.getItem('lastScenarioTab') || 'custom'
